import React, { useState, useCallback, useEffect } from "react";
import {
  View,
  TouchableNativeFeedback,
  StyleSheet,
  Alert,
  TouchableOpacity,
  Platform,
} from "react-native";
import Colors from "../../constants/Colors";
import { useSelector, useDispatch } from "react-redux";
import DefaultText from "../../components/text/DefaultText";
import DefaultTextBold from "../../components/text/DefaultTextBold";
import DraggableFlatList, {
  ScaleDecorator,
} from "react-native-draggable-flatlist";
import CastButton from "../../components/CastButton";
import { HeaderButtons, Item } from "react-navigation-header-buttons";
import alertWrapper from "../../components/web/alert.web";

import PlaylistItem from "../../components/PlaylistItem";
import { useNavigation } from "@react-navigation/native";
import { Ionicons } from "@expo/vector-icons";
import * as deviceActions from "../../store/actions/device";

const DeviceDetailScreen = (props) => {
  const navigation = useNavigation();
  const dispatch = useDispatch();

  const { deviceId, togglePlaySwitch } = props.route.params;
  const socket = useSelector((state) => state.socket.io);
  console.log("deviceId", deviceId);

  const myDevices = useSelector((state) => state.devices.myDevices);
  const selectedDevice = myDevices.find(
    (device) => device.deviceId == deviceId
  );
  const isPlay = selectedDevice.settings.mode === "play";

  const playlist = selectedDevice.playlist;
  let TouchableCmp = TouchableOpacity;
  if (Platform.OS === "android" && Platform.Version >= 21) {
    TouchableCmp = TouchableNativeFeedback;
  }
  // const [data, setData] = useState(() => popularNfts);
  const [data, setData] = useState(() => playlist);
  const speeds = ["5s", "10s", "30s", "1m", "5m", "10m"];
  const [selectedSpeed, setSelectedSpeed] = useState(speeds[0]);
  const slectSpeedHandler = (speed) => {
    setSelectedSpeed(speed);
    console.log("speed:", speed);
    dispatch(
      deviceActions.updateDeviceSetting(deviceId, "speed", speed, socket)
    );
  };

  useEffect(() => {
    setData(playlist);
  }, [playlist]);

  React.useLayoutEffect(() => {
    props.navigation.setOptions({
      headerRight: () => (
        <HeaderButtons HeaderButtonComponent={CastButton}>
          <Item
            title="Settings"
            iconName={"settings-outline"}
            onPress={() =>
              props.navigation.navigate("DeviceSettingScreen", {
                deviceId: deviceId,
              })
            }
          />
        </HeaderButtons>
      ),
    });
  }, [props.navigation]);
  const shuffleDeck = () => {
    let newArray = [...data];
    let i = newArray.length - 1;
    for (; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = newArray[i];
      newArray[i] = newArray[j];
      newArray[j] = temp;
    }
    setData(newArray);
    // console.log("newArray:");
    // newArray.forEach((item) => console.log(item.title));
    // console.log("data:");
    // data.forEach((item) => console.log(item.title));
    dispatch(deviceActions.updateDevicePlaylist(deviceId, newArray, socket));
  };
  const deleteHandler = (id) => {
    console.log("deleteHandler");
    alertWrapper("Are you sure?", "Do you really want to delete this item?", [
      { text: "No", style: "cancel" },
      {
        text: "Yes",
        style: "confirm",
        onPress: () => {
          //dispatch(productsActions.deleteProduct(id));
          const newArray = data.filter((item) => item.id !== id);
          setData(newArray);
          dispatch(
            deviceActions.updateDevicePlaylist(deviceId, newArray, socket)
          );
        },
      },
    ]);
  };
  const dragEndHandler = (data) => {
    setData(data);
    dispatch(deviceActions.updateDevicePlaylist(deviceId, data, socket));
  };
  const renderItem = useCallback(
    ({ item, drag, isActive }) => {
      return (
        <TouchableOpacity
          activeOpacity={0.5}
          onPress={() => {
            //https://github.com/react-navigation/react-navigation/issues/6434
            navigation.navigate("DeviceArtScreen", {
              itemId: item.id,
              from: "DeviceDetailScreen",
            });
          }}
          style={[styles.rowItem]}
        >
          <PlaylistItem
            title={item.title}
            artist={item.artist}
            imageUrl={item.imageUrl}
            collectionImageUrl={item.collectionImageUrl}
            drag={drag}
            delete={() => {}}
            isActive={isActive}
            delete={() => deleteHandler(item.id)}
          />
        </TouchableOpacity>
      );
    },
    [data]
  );

  return (
    <View style={styles.screen}>
      <View style={styles.firstRow}>
        <DefaultTextBold>Playlist Speed</DefaultTextBold>

        {/* FIXME <TouchableCmp
          onPress={() => {
            togglePlaySwitch(isPlay);
          }}
        >
          <Ionicons name={isPlay ? "pause" : "play"} size={22} color="white" />
        </TouchableCmp> */}
      </View>
      <View style={styles.hline} />
      <View style={styles.speedContainer}>
        {speeds.map((speed) => {
          return (
            <TouchableOpacity
              style={styles.a}
              onPress={() => {
                slectSpeedHandler(speed);
              }}
              key={speed}
            >
              <DefaultTextBold
                style={[
                  styles.speedTextContainer,
                  {
                    backgroundColor:
                      speed === selectedSpeed ? "white" : Colors.background,
                    color: speed === selectedSpeed ? "black" : Colors.primary,
                  },
                ]}
              >
                {speed}
              </DefaultTextBold>
            </TouchableOpacity>
          );
        })}
      </View>
      {/* <TouchableOpacity
        style={styles.speedTextContainer}
        onPress={() => {
          dispatch(
            deviceActions.updateDeviceSetting(
              deviceId,
              "orientation",
              "90",
              socket
            )
          );
        }}
      >
        <DefaultTextBold>Orientation</DefaultTextBold>
      </TouchableOpacity> */}
      <View style={styles.playlistContainer}>
        <DefaultTextBold> Playlist</DefaultTextBold>
        <TouchableOpacity
          style={styles.shuffleContainer}
          onPress={() => shuffleDeck(data)}
        >
          <Ionicons
            style={styles.icon}
            name="shuffle-outline"
            size={18}
            color="white"
          />
          <DefaultTextBold>{"  "}Shuffle</DefaultTextBold>
        </TouchableOpacity>
      </View>
      <View style={styles.hline} />
      <View style={styles.dragContainer}>
        {playlist && playlist.length ? (
          <DraggableFlatList
            data={data}
            onDragEnd={({ data }) => dragEndHandler(data)}
            keyExtractor={(item) => item.id}
            renderItem={renderItem}
          />
        ) : (
          <DefaultText>Nothing to Cast</DefaultText>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: Colors.background,
    margin: 16,
    //alignItems: "center",
    //justifyContent: "center",
  },
  firstRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  speedContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
    marginVertical: 8,
  },
  speedTextContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
    borderWidth: 1,
    borderColor: "white",
    padding: 8,
  },
  playlistContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 56,
  },
  shuffleContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
  },
  hline: {
    borderBottomColor: Colors.primary,
    borderBottomWidth: 1,
    width: "100%",
    marginVertical: 8,
  },
  rowItem: {
    alignItems: "center",
    //justifyContent: "center",
  },
  dragContainer: {
    flex: 1,
    height: "100%",
    width: "100%",
    //alignItems: "center",
    //justifyContent: "flex-start",
    marginVertical: 10,
  },
});

export default DeviceDetailScreen;
